(function () {
  // Loaded once per pro-testimonials instance; the first run mounts every instance,
  // and SectionSwipers re-mounts a section when the theme editor adds or re-renders it
  if (window.proTestimonialsSwiper) return;
  window.proTestimonialsSwiper = true;

  SectionSwipers.mountEach('.pro-testimonials', function (root) {
    return Array.from(root.querySelectorAll('.pro-testimonials')).map(function (section) {
      var track = section.querySelector('.pro-testimonials__carousel');
      if (!track || typeof Swiper === 'undefined') return null;

      return new Swiper(track, {
        slidesPerView: 1.15,
        spaceBetween: 16,
        navigation: {
          nextEl: section.querySelector('.pro-testimonials__button--next'),
          prevEl: section.querySelector('.pro-testimonials__button--prev')
        },
        pagination: {
          el: section.querySelector('.pro-testimonials__pagination'),
          type: 'progressbar'
        },
        breakpoints: {
          768: {
            slidesPerView: 3,
            spaceBetween: 24,
            allowTouchMove: false
          }
        }
      });
    });
  });
})();
